<script setup>
import { InformationCircleIcon, ShieldExclamationIcon, CheckCircleIcon } from '@heroicons/vue/outline'
import {Link} from "@inertiajs/vue3";

const props = defineProps({
    message: {
        default: 'This is the default message for this info alert. Change me',
        type: String
    },
    link: {
        default: null,
        type: String
    },
    linkTitle: {
        default: null,
        type: String
    },
    type: {
        default: 'info',
        type: String
    }
})
</script>

<template>
    <div class="rounded-md p-4" :class="{'bg-red-50':  type === 'danger', 'bg-blue-50': type === 'info', 'bg-yellow-50': type === 'warning', 'bg-green-50': type === 'success'}">
        <div class="flex">
            <div class="flex-shrink-0">
                <ShieldExclamationIcon v-if="type === 'danger' || type === 'warning'" class="h-5 w-5" :class="{'text-red-400': type ==='danger', 'text-yellow-400' : type === 'warning'}" aria-hidden="true" />
                <CheckCircleIcon v-else-if="type === 'success'" class="h-5 w-5 text-green-400" aria-hidden="true" />
                <InformationCircleIcon v-else class="h-5 w-5 text-blue-400" aria-hidden="true" />
            </div>
            <div class="ml-3 flex-1 md:flex md:justify-between">
                <p class="text-sm"  :class="{'text-red-700':  type === 'danger', 'text-blue-700': type === 'info', 'text-yellow-700': type === 'warning', 'text-green-700' : type === 'success'}">{{ message }}</p>
                <p class="mt-3 text-sm md:mt-0 md:ml-6">
                    <Link v-if="link !== null" :href="link" class="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600" :title="linkTitle">
                        {{ linkTitle }}
                        <span aria-hidden="true"> &rarr;</span>
                    </Link>
                </p>
            </div>
        </div>
    </div>
</template>

